/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_TcInputs */

const en_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const fr_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const de_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const it_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const ru_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТК`)
};

const es_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const zh_cn2_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const ja_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

const hi_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीसी`)
};

const pt_pt2_ccsl_export_header_tc = /** @type {(inputs: Ccsl_Export_Header_TcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TC`)
};

/**
* | output |
* | --- |
* | "TC" |
*
* @param {Ccsl_Export_Header_TcInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_tc = /** @type {((inputs?: Ccsl_Export_Header_TcInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_TcInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_tc(inputs)
	if (locale === "de") return de_ccsl_export_header_tc(inputs)
	if (locale === "it") return it_ccsl_export_header_tc(inputs)
	if (locale === "ru") return ru_ccsl_export_header_tc(inputs)
	if (locale === "es") return es_ccsl_export_header_tc(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_tc(inputs)
	if (locale === "ja") return ja_ccsl_export_header_tc(inputs)
	if (locale === "hi") return hi_ccsl_export_header_tc(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_tc(inputs)
	return en_ccsl_export_header_tc(inputs)
});